<div class="flex lg:flex-row flex-col gap-4">
    <a [class]="classi" [href]="href" target="_blank" [class.disabled]="disable" *ngIf="visible">{{ testo }}</a>
    <a [class]="classi" [href]="href_custom" target="_blank" [class.disabled]="disable" *ngIf="(href_custom || '').length > 0">{{ testo_custom }}</a>
</div>